import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePutDesativarTerminal() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putDesativarTerminal = useCallback(
        (id: string) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/terminal/desativar?id=${id}`,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putDesativarTerminal,
    };
}
